import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import { useMemo } from "react";
import { Metric } from "@/api/generated/models";
import { MapLegendContainer } from "@/components/ui/legends/MapLegendContainer";
import { VehicleTypeLegend } from "@/components/ui/legends/VehicleTypeLegend";
import { GradientLegend } from "@/components/ui/legends/GradientLegend";
import { RangeMetric, RangeValues } from "@/components/ui/filters/metrics/MetricFilter";
import { ToggleMetric } from "@/utils/metricUtils";
import { useMetricRanges, useVehicleTypes } from "@/api/hooks/useStats";
import { TrajectoryPointDtoVehicleType } from "@/api/generated/models/trajectoryPointDtoVehicleType";
interface MetricsViewOverlayProps {
  selectedMetric: ToggleMetric;
  displayedVehicleTypes: TrajectoryPointDtoVehicleType[];
  rangeValues: RangeValues | null;
}
export const MetricsViewOverlay = t0 => {
  const $ = _c(10);
  const {
    selectedMetric,
    displayedVehicleTypes,
    rangeValues
  } = t0;
  const {
    data: vehicleTypesData
  } = useVehicleTypes();
  const {
    data: metricRanges
  } = useMetricRanges();
  let t1;
  if ($[0] !== metricRanges) {
    t1 = metricRanges?.speed && metricRanges?.acceleration && metricRanges?.density ? {
      speed: metricRanges.speed.absolute,
      acceleration: metricRanges.acceleration.absolute,
      density: metricRanges.density.absolute
    } : null;
    $[0] = metricRanges;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const datasetRanges = t1;
  let t2;
  if ($[2] !== datasetRanges || $[3] !== displayedVehicleTypes || $[4] !== rangeValues || $[5] !== selectedMetric || $[6] !== vehicleTypesData?.vehicleTypes) {
    t2 = selectedMetric === Metric.vehicleType ? <VehicleTypeLegend displayedVehicleTypes={displayedVehicleTypes} availableVehicleTypes={vehicleTypesData?.vehicleTypes} /> : rangeValues?.[selectedMetric as RangeMetric] ? <GradientLegend metric={selectedMetric as RangeMetric} range={rangeValues[selectedMetric as RangeMetric]} datasetRange={datasetRanges?.[selectedMetric as RangeMetric]} /> : null;
    $[2] = datasetRanges;
    $[3] = displayedVehicleTypes;
    $[4] = rangeValues;
    $[5] = selectedMetric;
    $[6] = vehicleTypesData?.vehicleTypes;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <Box position="absolute" top="24" right="4" zIndex="4"><MapLegendContainer>{t2}</MapLegendContainer></Box>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
};